import React, { useState, useRef, useEffect } from 'react'
import { Sidebar } from './Sidebar'
import { Editor } from './Editor'
import { Terminal } from './Terminal'
import SplitPane, { Pane } from '../../../../plugin/react-split-pane'
import { CreateFunctionProvider } from './CreateFunctionContext'
import { IState } from './CreateFunctionContext'
import style from './styles/create-function.module.css'
import './styles/overrides.css'

type SplitView = 'vertical' | 'horizontal'

const CreateFunction: React.FC<{ state?: IState }> = (props) => {
  const { state } = props
  const functionId = state?.metadata?.id || ""
  const [editorSplitView, setEditorSplitView] = useState<SplitView>('vertical')
  const [isExecuting, setIsExecuting] = useState(false)
  const [isRelease, setIsRelease] = useState(false)

  const [paneSize, setPaneSize] = useState({
    sidebar: '350px',
    terminal: '350px',
  })

  useEffect(() => {
    setIsRelease(Boolean(functionId))
  }, [functionId, setIsRelease])

  const updatePaneSize = (pane: 'sidebar' | 'terminal', size: string) =>
    setPaneSize((prevState) => ({ ...prevState, [pane]: size }))

  // refs
  const terminalRef = useRef<any>(null)     // to clear the terminal programmatically
  const editorRef = useRef<any>(null)       // to set the editor content when needed
  const paneEditorRef = useRef<any>(null)   // to calc the height/width of the editor

  const { offsetWidth: paneWidth, offsetHeight: paneHeight } =
    paneEditorRef.current?.splitPane || {}

  return (
    <CreateFunctionProvider>
      <SplitPane
        split="vertical"
        defaultSize={350}
        onChange={(size: [string, string]) => {
          const [value] = size
          updatePaneSize('sidebar', value)
        }}
      >
        <Pane
          className="sidebarPane"
          minSize="350px"
          initialSize={paneSize.sidebar}
        >
          <Sidebar state={state} />
        </Pane>

        <SplitPane
          split={editorSplitView}
          ref={paneEditorRef}
          defaultSize={
            editorSplitView === 'vertical' ? paneHeight - 350 : paneWidth - 350
          }
          onChange={(size: [string, string]) => {
            const [, value] = size
            updatePaneSize('terminal', value)
          }}
        >
          <Pane>
            <Editor
              terminalRef={terminalRef}
              setIsExecuting={setIsExecuting}
              editorRef={editorRef}
              isRelease={isRelease}
              setIsRelease={setIsRelease}
            />
          </Pane>
          <Pane
            className={style.terminalPane}
            initialSize={paneSize.terminal}
          >
            <Terminal
              isExecuting={isExecuting}
              terminalRef={terminalRef}
              setEditorSplitView={setEditorSplitView}
              editorRef={editorRef}
              editorSplitView={editorSplitView}
            />
          </Pane>
        </SplitPane>
      </SplitPane>
    </CreateFunctionProvider>
  )
}

export default CreateFunction
